

export const AUTH_TOKEN = "MOSANIC_USR_TKN";
export const AUTH_EMAIL_REF = "MOSANIC_EMAIL_REF"
